import React from "react";

import Link from "next/link";

import PropTypes from "prop-types";

import { seeMoreStyle } from "./SeeMore.style";

export const propTypes = {
  rowTitle: PropTypes.string,
  seeMoreURL: PropTypes.string,
};

export const SeeMore = (props) => {
  const { seeMoreURL, rowTitle } = props;

  return (
    <Link href={seeMoreURL} passHref legacyBehavior>
      <a css={seeMoreStyle}>{`See More in ${rowTitle}`}</a>
    </Link>
  );
};

SeeMore.propTypes = propTypes;
export default SeeMore;
